import { createFileRoute, notFound } from "@tanstack/react-router";
import { PageContent } from "@/components/layout/page-content";
import { DEFERRED_ROUTES } from "@/lib/feature-flags";

export const Route = createFileRoute("/(dashboard)/settings/api")({
	beforeLoad: () => {
		if (DEFERRED_ROUTES) throw notFound();
	},
	component: ApiPage,
});

function ApiPage() {
	return (
		<PageContent title="API">
			<div />
		</PageContent>
	);
}
